import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProdutosPage from "../pages/produtos/page";
import ProdutoDetailPage from "../pages/produtos/detail";
import AtasConsultaPage from "../pages/atas/page";
import PrivacyPolicyPage from "../pages/legal/PrivacyPolicyPage";
import TermsOfUsePage from "../pages/legal/TermsOfUsePage";
import AdminLayout from "../pages/admin/layout";
import DashboardPage from "../pages/admin/dashboard/page";
import AtasPage from "../pages/admin/atas/page";
import ProdutosAdminPage from "../pages/admin/produtos/page";

import AdminLoginPage from "../pages/admin/login/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produtos",
    element: <ProdutosPage />,
  },
  {
    path: "/produtos/:id",
    element: <ProdutoDetailPage />,
  },
  {
    path: "/atas",
    element: <AtasConsultaPage />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/termos-de-uso",
    element: <TermsOfUsePage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <DashboardPage />,
      },
      {
        path: "atas",
        element: <AtasPage />,
      },
      {
        path: "produtos",
        element: <ProdutosAdminPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
